'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { AnimatedButton, type ButtonSize, type ButtonVariant } from '@/components/ui/animated-button';
import { RotateClockwiseIcon } from '@/components/ui/icon/glyphs';
interface RetryButtonProps {
  readonly onRetry: () => void;
  readonly children: ReactNode;
  readonly variant?: ButtonVariant | undefined;
  readonly size?: ButtonSize | undefined;
}

/** Consistent retry action for initial and inline recoverable error states. */
export function RetryButton(t0) {
  const $ = _c(5);
  const {
    onRetry,
    children,
    variant: t1,
    size
  } = t0;
  const variant = t1 === undefined ? "secondary" : t1;
  let t2;
  if ($[0] !== children || $[1] !== onRetry || $[2] !== size || $[3] !== variant) {
    t2 = <AnimatedButton variant={variant} size={size} prefix={RotateClockwiseIcon} onClick={onRetry}>{children}</AnimatedButton>;
    $[0] = children;
    $[1] = onRetry;
    $[2] = size;
    $[3] = variant;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}